import { withDependencies } from '@wix/thunderbolt-ioc'
import type {
	BrowserWindow,
	IAppDidMountHandler,
	IAppWillUnmountHandler,
	ViewerModel } from '@wix/thunderbolt-symbols'
import {
	BrowserWindowSymbol,
	ViewerModelSym,
} from '@wix/thunderbolt-symbols'
import { isSSR } from '@wix/thunderbolt-commons'
import { OnLinkClickSymbol } from './symbols'
import type { IOnLinkClickHandler } from './types'
import React from 'react'

const clickHandlerRegistrarFactory = (
	browserWindow: NonNullable<BrowserWindow>,
	{ onLinkClick }: IOnLinkClickHandler,
	viewerModel: ViewerModel
): IAppDidMountHandler & IAppWillUnmountHandler => {
	return {
		appDidMount: () => {
			if (isSSR(browserWindow)) {
				return
			}
			browserWindow.addEventListener('click', onLinkClick)
			if (viewerModel.mode.debug && React.version.startsWith('18')) {
				// for some reason react 18 strict mode doesn't fire click events on window
				Array.from(document.querySelectorAll?.('a') || []).map((e) => e.addEventListener('click', onLinkClick))
			}
		},
		appWillUnmount: () => {
			browserWindow.removeEventListener('click', onLinkClick)
		},
	}
}

export const ClickHandlerRegistrar = withDependencies(
	[BrowserWindowSymbol, OnLinkClickSymbol, ViewerModelSym],
	clickHandlerRegistrarFactory
)
